import { EditorState, Plugin, Transaction } from 'prosemirror-state'
import { pick } from 'lodash'
import RingBuffer from 'ringbufferjs'

export const buffer = new RingBuffer(5)

export const DataLossDebug = new Plugin({
  appendTransaction: (transactions: Transaction[], oldState: EditorState, newState: EditorState) => {
    const preservedData = transactions.map(filterTransactionForDebug)

    buffer.enq({ time: new Date().getTime(), docBefore: oldState.toJSON(), transactions: preservedData })
  },
})

export const filterTransactionForDebug = (tr: Transaction) => {
  const filteredTr: any = pick(tr, ['meta', 'steps', 'selection'])
  filteredTr.steps = filteredTr.steps.map((step: Transaction['steps'][number]) => step.toJSON())
  filteredTr.selection = filteredTr.selection.toJSON()
  return filteredTr
}
